<script>

export default {

   props: {
      json: Object
   },

   methods: {
      getAsset(type, id) {
         let result;
         if (type === 'media') {
            result = this.json.tmpl.assets.filter(obj => {
               return obj.id === id;
            });
         } else {
            result = this.json.tmpl.data.text.filter(obj => {
               return obj.id === id;
            });
         }
         return result[0];
         
      },

      getImageStyle(zone) {
         let transformScale = '';
         if (zone.scaleX < 0) {
            transformScale += ' scaleX(-1)';
         }
         if (zone.scaleY < 0) {
            transformScale += ' scaleY(-1)';
         }

         return 'left: ' + zone.assetX + 'px; top: ' + zone.assetY + 'px; width: ' + zone.assetW * Math.abs(zone.scaleX) + 'px; transform: rotate(' + zone.rotation + 'deg) '  + transformScale + ';';
      },

      //handles styling the image according to the JSON
      //positions it correctly and handles sizing and rotation
      imagePos(zone) {
         return 'transform: rotate(' + zone.rotation + 'deg); top: ' + zone.assetY + 'px; left: '+zone.assetX+ 'px; width: '+ zone.assetW * zone.scaleX +'px;';
      }
   }
}
</script>